import { render } from "./ListeTarification.vue?vue&type=template&id=f8a41394&ts=true"
import script from "./ListeTarification.vue?vue&type=script&lang=ts"
export * from "./ListeTarification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__